import { Toman } from '@/components/svg-symbols/icons';
import { cn } from '@/utils/cn';
import { toNumberCommas } from '@/utils/string-helpers';
interface Props {
  price: number;
  title?: string;
  className?: string;
}
export const BasketPricing = ({
  price,
  className,
  title = 'جمع سبد خرید'
}: Props) => {
  const isFree = price === 0;
  return <div className={cn('flex w-fit flex-col items-center gap-1', className)} data-sentry-component="BasketPricing" data-sentry-source-file="basket-pricing.tsx">
            <span className='text-body-14 text-text-mediumGray'>{title}</span>

            <div className='flex items-center gap-1'>
                <span className='text-body-16 font-medium text-text-black'>
                    {isFree ? 'رایگان' : toNumberCommas(price)}
                </span>

                {!isFree && <Toman className='h-6 w-6 text-text-black' />}
            </div>
        </div>;
};